import { rangeColors } from './consts'

const baseStyle = {
  container: {
    w: 1,
  },
  thumb: {
    bg: 'white',
    border: '2px solid',
    borderRadius: '24px',
    h: '24px',
    lineHeight: '24px',
    w: '24px',
    textAlign: 'center',
    transitionDuration: '0s',
  },
  thumbValue: {
    position: 'absolute',
    top: '24px',
    w: '18px',
  },
  track: {
    bg: rangeColors.main,
    borderRadius: '24px',
    transitionDuration: '0s',
  },
}

const defaultProps = {}

const parts = ['container', 'thumb', 'thumbValue', 'track']

const sizes = {}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
